import { TASK_PAGE_ICON_KEYS, TASK_PAGE_NAV_GROUPS } from "./taskPages";

/**
 * Org-configurable "Agent Pages" — one background agent mounted into the
 * sidebar as its own page (live monitor, reasoning trail, task queue, and a
 * durable Run button), the agent-shaped sibling of task pages.
 *
 * Agent pages share the task-page sidebar vocabulary on purpose: the same
 * section labels (so both kinds of page can sit in one section) and the same
 * icon set (one picker, one renderer). They are re-exported under their own
 * names so a future split does not ripple through every consumer.
 */
export const AGENT_PAGE_NAV_GROUPS = TASK_PAGE_NAV_GROUPS;
export type AgentPageNavGroup = (typeof AGENT_PAGE_NAV_GROUPS)[number];

export const AGENT_PAGE_ICON_KEYS = TASK_PAGE_ICON_KEYS;
export type AgentPageIconKey = (typeof AGENT_PAGE_ICON_KEYS)[number];
